import { createStyles, Group, Stack } from '@mantine/core';
import type { ScanResultItem } from '@repo/api-codegen';
import RichTooltip from '@repo/common/components/RichTooltip/RichTooltip';
import { Badge } from '@repo/foundations';

const useStyles = createStyles(() => ({
	tooltipContainer: {
		maxHeight: '480px',
		maxWidth: '240px',
		overflowY: 'auto',
	},
}));

export function PolicyDataSamples({
	dataSamples,
	displayLimit = 3,
}: {
	dataSamples: ScanResultItem[];
	displayLimit?: number;
}) {
	const { classes } = useStyles();
	if (dataSamples.length === 0) {
		return null;
	}
	const displayResults = dataSamples
		.slice(0, displayLimit)
		.map((sample) => sample.suspect);
	const remainingResults = dataSamples
		.slice(displayLimit)
		.map((sample) => sample.suspect);

	const remaining = remainingResults.length;

	const tooltipBody = (
		<Stack spacing="xs" className={classes.tooltipContainer}>
			{remainingResults.map((result) => (
				<Badge key={result} w="fit-content" sx={{ textTransform: 'none' }}>
					{result}
				</Badge>
			))}
		</Stack>
	);

	return (
		<Group spacing="xs" p={0}>
			{displayResults.map((result) => (
				<Badge key={result} w="fit-content" sx={{ textTransform: 'none' }}>
					{result}
				</Badge>
			))}
			{remaining > 0 && (
				<RichTooltip body={tooltipBody}>
					<Badge w="fit-content" sx={{ textTransform: 'none' }}>
						+{remaining} more
					</Badge>
				</RichTooltip>
			)}
		</Group>
	);
}
